/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import RectangleLoader from "../../../../../shared/components/loaders/RectangleLoader";
import { useStyles } from "../styles";
import { NEWS_DIALOG_SIZES } from "../types/enums";
import NewsImage from "./NewsImage";

interface NewsImageContainerProps {
  image: string | undefined;
  listItem?: boolean;
  isLoading?: boolean;
}

const NewsImageContainer = ({
  image,
  listItem,
  isLoading
}: NewsImageContainerProps) => {
  const { newsImageBox } = useStyles({
    listItem
  });

  const shouldHaveLoader = isLoading && !listItem;

  return (
    <div
      data-testid="news-image-container"
      css={css({
        width: "100%"
      })}
    >
      {shouldHaveLoader && (
        <RectangleLoader
          testId="news-image-loader"
          width={NEWS_DIALOG_SIZES.dialogContentLoaderWidth}
          height={NEWS_DIALOG_SIZES.dialogContentLoaderHeight}
        />
      )}
      {!shouldHaveLoader && (
        <div css={css([newsImageBox])} data-testid="news-image-block">
          {image ? (
            <NewsImage image={image} />
          ) : (
            <NewsImage image={`../img/no_image.svg`} />
          )}
        </div>
      )}
    </div>
  );
};

export default NewsImageContainer;
